import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import { selectToken } from '../selectors';

export function* getTimesheetsRequestSaga(payload) {
  try {
    const res = yield send({
      url: '/timesheets',
      method: 'GET',
      data: payload.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.getTimesheetsRequestSuccess(res));
  } catch (error) {
    yield put(actions.getTimesheetsRequestFailure(error));
  }
}
